import { APP_CONFIG } from "./constants";

const TOKEN_KEY = APP_CONFIG.STORAGE_KEYS.TOKEN;
const REFRESH_KEY = APP_CONFIG.STORAGE_KEYS.REFRESH;

type NativeTokenResponse = {
  success?: boolean;
  accessToken?: string;
};

export const hasNativeAuthBridge = (): boolean =>
  typeof window !== "undefined" &&
  typeof (window as any).flutter_inappwebview?.callHandler === "function";

export const clearMobileRefreshToken = (): void => {
  if (!hasNativeAuthBridge()) return;
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem("refreshToken");
  sessionStorage.removeItem(REFRESH_KEY);
  sessionStorage.removeItem("refreshToken");
};

export const requestNativeAccessToken = async (
  forceRefresh = false,
): Promise<string | null> => {
  if (!hasNativeAuthBridge()) return null;
  clearMobileRefreshToken();
  try {
    const rejectedAccessToken = localStorage.getItem(TOKEN_KEY);
    const request = (window as any).flutter_inappwebview.callHandler(
      "GetAccessToken",
      { forceRefresh, rejectedAccessToken },
    ) as Promise<NativeTokenResponse | null>;
    const timeout = new Promise<null>((resolve) => {
      window.setTimeout(() => resolve(null), 8_000);
    });
    const result = await Promise.race([request, timeout]);
    const token = result?.success ? result.accessToken?.trim() : null;
    if (!token) return null;
    localStorage.setItem(TOKEN_KEY, token);
    window.dispatchEvent(new CustomEvent("auth-state-changed"));
    return token;
  } catch {
    return null;
  }
};
